import { Outlet } from 'react-router-dom';
import { Sidebar } from '../components/Sidebar';

export function AppLayout() {
  return (
    <div className="app-shell">
      <Sidebar />
      <div className="app-main-column">
        <div className="app-topbar" aria-hidden="true" />
        <div className="app-main">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
